import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  total_to_pay: 0,
  subtotal: 0,
  charges_per_service: 0,
  discount: 0,
  promotion_code: null,
  commissions: null,
  isLoading: false,
};

const slice = createSlice({
  name: 'summary',
  initialState: reHydrateStore('summary') || initialState,
  reducers: {
    setSummary: (state, { payload }) => ({ ...state, ...payload }),
    setIsLoading: (state, { payload }) => ({
      ...state,
      isLoading: payload,
    }),
    restore: () => {},
  },
});

export const { setSummary, setIsLoading, restore } = slice.actions;

export default slice.reducer;

export const selectConfig = (state) => state.summary;
